export const DEFAULT_SLIDER_HEIGHT = 122;
